// extracted by mini-css-extract-plugin
export default {"remoteBlock":"RemoteWork_remoteBlock__7bgtn","remoteContainer":"RemoteWork_remoteContainer__dIBJW","viewBtn":"RemoteWork_viewBtn__cnQYr"};